import { gql } from "gql";

export const DELETE_COMPANY_DOCUMENTS = gql(/* GraphQL */ `
  mutation DeleteCompanyDocument($id: ID!) {
    deleteCompanyDocument(id: $id)
  }
`);
